import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faLocationDot, faPhoneFlip, faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MapEmbed from "../utils/map";

export const FooterComponent = () => {
    return (
        <footer>
            <div className="footer-top">
                <img src="/logos/logo.png" alt="" className="footer-img" />
                <div className="footer-slogan">
                    Achetez chez nous les smartphones les plus avancés au monde et des accessoires de précision.
                </div>
            </div>
            <div className="footer-mid">
                <div className="mid-section">
                    <div className="section-header">Liens rapides</div>
                    <a href="/fr" className="q-footer-link">Acceuille</a>
                    <a href="/fr/wishlist" className="q-footer-link">Liste d'envies</a>
                    <a href="/fr/cart" className="q-footer-link">Panier</a>
                    <a href="/fr/categories" className="q-footer-link">Catégories</a>
                </div>
                <div className="mid-section">
                    <div className="section-header">Contact</div>
                    <div className="cont-unit">
                        <FontAwesomeIcon icon={faPhoneFlip} className="cont-icon" />
                        <div className="cont-text">+237 698250070</div>
                    </div>
                    <div className="cont-unit">
                        <FontAwesomeIcon icon={faEnvelope} className="cont-icon" />
                        <div className="cont-text">kevotelecom@gmail.com</div>
                    </div>
                    <div className="cont-unit">
                        <FontAwesomeIcon icon={faLocationDot} className="cont-icon" />
                        <div className="cont-text">Rue 1154, Douala</div>
                    </div>
                    <div className="cont-unit"></div>
                </div>
                <div className="mid-section">
                    <MapEmbed />
                </div>

            </div>
            <hr style={{ marginTop: 32 }} />
            <div className="footer-bottom">
                <div className="footer-bottom-section">
                    <a href="https://facebook.com/KevoCEO" className="soc-link">
                        <FontAwesomeIcon icon={faFacebook} className="cont-icon" />
                    </a>
                    <a href="https://www.instagram.com/kevo_telecom" className="soc-link">
                        <FontAwesomeIcon icon={faInstagram} className="cont-icon" />
                    </a>
                    <a href="https://www.tiktok.com/@kevotelecom" className="soc-link">
                        <FontAwesomeIcon icon={faTiktok} className="cont-icon" />
                    </a>
                </div>
            </div>
        </footer>
    )
}